/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { twMerge } from 'utilities/src/twMerge';
import { type IProps } from 'ui/src/components/Button/shared/types/_props';
import ButtonLink from 'ui/src/components/Button/ButtonLink';
import IconComponent from 'ui/src/components/Icon';
import { ThemeEnum } from 'ui/src/components/Theme';
import BrandedLeading from 'ui/src/components/BrandedLeading';
import useFooterThemes from './themes';

export type GetInTouchProps<Theme extends ThemeEnum = ThemeEnum> = {
  scheduleCallBtn: IProps<Theme> & { href?: string };
  contactUsBtn: IProps<Theme>;
  withFullStops?: boolean;
  contactusUrl: string;
  containerClasses?: string;
  buttonContainerClasses?: string;
  onClickScheduleCall?: () => void;
  onClickContactUs?: () => void;
};

export default function GetInTouch<Theme extends ThemeEnum = ThemeEnum>({
  scheduleCallBtn,
  contactUsBtn,
  withFullStops,
  contactusUrl,
  containerClasses,
  buttonContainerClasses,
  onClickContactUs,
  onClickScheduleCall,
}: GetInTouchProps<Theme>) {
  const {
    footerGetInContainerClasses,
    footerGetInTitleClasses,
    footerGetInButtonsClasses,
    footerGetInPhoneClasses,
    footerGetInPhoneIconClasses,
    footerGetInTouchButtonsClasses,
  } = useFooterThemes();

  return (
    <section className={twMerge(footerGetInContainerClasses, containerClasses)}>
      <BrandedLeading as="p" classes={twMerge(footerGetInTitleClasses)} addBrandedFullStop={withFullStops}>
        Get in touch
      </BrandedLeading>
      <div className={twMerge(footerGetInButtonsClasses, buttonContainerClasses)}>
        <ButtonLink<Theme>
          prefetch={false}
          href="https://www.bairesdev.com/start/basic-details/"
          target="_blank"
          rel="noreferrer"
          classes={twMerge(footerGetInTouchButtonsClasses, 'h-11')}
          size="Large"
          onClick={onClickScheduleCall}
          {...scheduleCallBtn}
        >
          Schedule a Call
        </ButtonLink>
        <ButtonLink<Theme>
          prefetch={false}
          href={contactusUrl}
          rel="noreferrer"
          size="Large"
          classes={twMerge(footerGetInTouchButtonsClasses, 'h-11')}
          onClick={onClickContactUs}
          {...contactUsBtn}
        >
          Contact Us
        </ButtonLink>
        <div className={twMerge(footerGetInPhoneClasses)}>
          <IconComponent iconName="Call" className={twMerge(footerGetInPhoneIconClasses)} size="IconS" />
          <a href="tel:+14084782739">+1 (408) 478-2739</a>
        </div>
      </div>
    </section>
  );
}
